<div class="">
    <app-header [id]="id!"></app-header>
</div>


<ng-container *ngIf="contactSignal()">
    <div class="bg-gray-30 lg:border-b border-gray-300 flex justify-center items-center ">
        <div class="flex flex-col justify-center items-center  max-w-[600px]">

            <fa-icon [icon]=" faEnvelope" class="text-[200px] text-custom-blue leading-none mb-8"></fa-icon>
            <span class="text-3xl font-bold font-mulish">Get in touch with us</span>
            <p class="mt-4 text-base text-gray-700 text-center">
                If you have questions regarding the <span>{{contactSignal()?.organizationName}}</span>, items in the
                auction, bidding, email
                communications, events or other general information, please contact
                <a href="" class="text-blue-600 underline">{{contactSignal()?.contactEmail}}</a>
            </p>

            <div class="flex flex-col  gap-10  pt-2 max-w-[400px] mb-20 mt-4">
                <div class="flex flex-wrap">
                    <p class="text-lg font-semibold font-mulish w-40"> Mailing Address </p>
                    <div class="flex-1 text-black text-base font-mulish leading-tight">
                        <p>{{contactSignal()?.organizationName}}</p>
                        <p>{{contactSignal()?.organizationAddress}}</p>
                    </div>
                </div>

                <div class="flex flex-wrap ">
                    <p class="font-semibold font-mulish w-40 text-lg ">
                        Phone
                    </p>
                    <div class="flex-1 text-black text-base font-mulish leading-tight lg:mt-2">
                        {{contactSignal()?.contactPhone}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<div>
    <app-footer></app-footer>
</div>